<div class="row" *ngIf="displayType === 'GenDebitOrderBatch'">
    <div class="col-md-12">
        <div class="row modal_header">
            <div class="col-9">
                <i class="fa-solid fa-envelope mr-3"></i>
                <span>Email Notification</span>
            </div>
            <div class="col-3 text-right">
                <a style="cursor:pointer">
                    <i class="fa-solid fa-xmark" (click)="Close()" style="font-size: x-large;"></i>
                </a>
            </div>
        </div>
        <div class="card card_content">
            <form [formGroup]="debitOrderBatchForm">
                <div class="row justify-content-center mb-3">
                    <div class="col-md-8">
                        <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                            <mat-label>Month and Year</mat-label>
                            <input readonly matInput [matDatepicker]="startDate" id="startDate"
                                formControlName="startDate" autocomplete="off" placeholder="Month and Year"
                                class="col-12 custom-input-border" specialIsAlphaNumeric required
                                (click)="OpenDatePicker()" style="color:black;" [min]="minDate" [max]="maxDate">
                            <mat-datepicker-toggle matSuffix [for]="startDate" style="color:black;">
                                <button mat-icon-button>
                                    <mat-icon>event</mat-icon>
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                        stroke="currentColor">
                                    </svg>
                                </button>
                            </mat-datepicker-toggle>
                            <mat-datepicker #startDate startView="multi-year"
                                (monthSelected)="setMonthAndYear($event, startDate)" panelClass="example-month-picker">
                            </mat-datepicker>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row justify-content-center mb-3">
                    <div class="col-md-8">
                        <mat-form-field class="p-0" appearance="fill" hideRequiredMarker>
                            <mat-label>Date of Debit</mat-label>
                            <mat-select class="scrollbarcs" formControlName="TrackFrogfoot"
                                placeholder="Select Date of Debit">
                                <mat-select-filter [displayMember]="'value'" [array]="DebitDateTypeList"
                                    (filteredReturn)="filteredListDebitDateTypeList = $event"></mat-select-filter>
                                <mat-option *ngFor="let role of filteredListDebitDateTypeList" [value]="role.key"
                                    style="overflow-y: scroll !important;">
                                    {{role.value}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row justify-content-center mb-3">
                    <div class="col-md-8">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Select Email Address</mat-label>
                            <mat-select class="scrollbarcs" formControlName="email" placeholder="Select Email Address">
                                <mat-select-filter [displayMember]="'value'" [array]="emailAddressList"
                                    (filteredReturn)="filteredListEmailAddressList = $event"></mat-select-filter>
                                <mat-option *ngFor="let role of filteredListEmailAddressList" [value]="role.value"
                                    style="overflow-y: scroll !important;">
                                    {{role.value}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row justify-content-center mb-3">
                    <div class="col-md-8">
                        <input type="checkbox" id="debitCheckbox" class="mr-2" (change)="OnClickCheckBox()"
                            formControlName="manualDebit" />
                        <label for="termsCheckbox" style="font-size:15px;color: gray">
                            Debit Report Manualy
                        </label>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <button class="btn btn-secondary" (click)="saveDebitOrderBatch()">
                        Submit
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
<div class="row" *ngIf="displayType === 'SendOverEmail'">
    <div class="col-md-12">
        <div class="row modal_header">
            <div class="col-9">
                <span>Email Notification</span>
            </div>
            <div class="col-3 text-right">
                <a style="cursor:pointer">
                    <i class="fa-solid fa-xmark" (click)="Close()" style="font-size: xx-large;"></i>
                </a>
            </div>
        </div>
        <div class="card card_content">
            <form [formGroup]="SendOverEmailForm">
                <div class="row d-flex justify-content-center align-items-center flex-wrap grid-margin"
                    style="flex-direction: column;">
                    <div class="col-md-9 mt-3">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Select Email Address</mat-label>
                            <mat-select class="scrollbarcs" formControlName="email" placeholder="Select Email Address">
                                <mat-select-filter [displayMember]="'value'" [array]="emailAddressList"
                                    (filteredReturn)="filteredListEmailAddressList = $event"></mat-select-filter>
                                <mat-option *ngFor="let role of filteredListEmailAddressList" [value]="role.value"
                                    style="overflow-y: scroll !important;">
                                    {{role.value}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-12 pb-1 mt-3 text-center">
                        <button type="button" class="btn btn-secondary" (click)="saveGenerateDebitOrderExcelSheet()">
                            Submit
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
<div class="row" *ngIf="displayType === 'MWRecInvoice'">
    <div class="col-md-12">
        <div class="row modal_header">
            <div class="col-9">
                <span><i class="fa-regular fa-circle-check mr-2"></i>{{MatDialogTitle}} </span>
            </div>
            <div class="col-3 text-right">
                <a style="cursor:pointer">
                    <i class="fa-solid fa-xmark" (click)="Close()" style="font-size: x-large;"></i>
                </a>
            </div>
        </div>
        <div class="card card_content">
            <div *ngIf="!isShowNextPage">
                <div class="row my-2">
                    <div class="col-12">
                        <span style="font-size: 16px;font-weight: 600;"> Please confirm can we proceed with creating
                            Recurring
                            Invoices?</span>
                    </div>
                </div>
                <div class="row my-2">
                    <div class="col-xl-12 d-flex" style="cursor: pointer;" title="Download Invoice"  (click)="downloadReport()">
                            <svg class="svg_filter mr-2" height="24" viewBox="0 0 24 24" fill="#9a00da"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M12 16L7 11L8.4 9.55L11 12.15V4H13V12.15L15.6 9.55L17 11L12 16ZM6 20C5.45 20 4.97933 19.8043 4.588 19.413C4.19667 19.0217 4.00067 18.5507 4 18V15H6V18H18V15H20V18C20 18.55 19.8043 19.021 19.413 19.413C19.0217 19.805 18.5507 20.0007 18 20H6Z"
                                    fill="#9a00da" />
                            </svg>
                        <span>Click here to download report</span>
                    </div>
                </div>



                <div class="row mt-3 text-center">
                    <div class="col-xl-12">
                        <button class="btn btn-secondary mr-3" (click)="Proceed()">Yes</button>
                        <button class="btn btn-primary" (click)="Close()">No</button>
                    </div>
                </div>
            </div>
            <div *ngIf="isShowNextPage">
                <div class="row">
                    <div class="col-12 d-flex">
                        <h5 *ngIf="customerVerification" style="color:green"> &#10004;&#65039; Customer
                            verification</h5>
                        <h5 *ngIf="!customerVerification" style="color:red"> &#10060; Customer
                            verification</h5>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 d-flex">
                        <h5 *ngIf="productVerification" style="color:green"> &#10004;&#65039; Product
                            verification</h5>
                        <h5 *ngIf="!productVerification" style="color:red"> &#10060; Product verification
                        </h5>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 d-flex">
                        <h5 style="color:green"> &#10004;&#65039; {{batches}} Batches {{counts}} Records in queue in
                            moneyworks
                        </h5>
                    </div>
                </div>
                <div class="row" *ngIf="customerVerification && productVerification">
                    <div class="col-12 d-flex justify-content-end" style="padding-top: 17px;padding-bottom: 17px;">
                        <button style="width: 290px !important;" class="btn btn-secondary button mr-3" (click)="ProceedInvoice()">Proceed</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="row" *ngIf="displayType === 'uploadExcelFile' || displayType === 'uploadExcelFileTable'">
    <div class="col-md-12">
        <div class="row modal_header">
            <div class="col-9">
                <span>{{title}}</span>
            </div>
            <div class="col-3 text-right">
                <a style="cursor:pointer">
                    <i class="fa-solid fa-xmark" (click)="Close()" style="font-size: x-large;"></i>
                </a>
            </div>
        </div>
        <div class="card card_content">
            <form [formGroup]="UploadExcelFileForm" *ngIf="displayType === 'uploadExcelFile'">
                <div>
                    <div style="font-size: 15px;">
                        Click on the upload button to upload the debit order report received from mail
                    </div>
                    <div class="row my-2 d-flex justify-content-center">
                        <div class="col-md-9 padd-right-file" style="display: flex;">
                            <mat-form-field appearance="fill" hideRequiredMarker (click)="selectFile()">
                                <mat-label>Debit order Report</mat-label>
                                <input matInput id="AttachmentFileName"
                                    [placeholder]="fileName ? '' : 'Select Attachment'" [value]="fileName"
                                    formControlName="AttachmentFileName" autocomplete="off" specialIsAlphaNumeric
                                    class="col-10" readonly>
                            </mat-form-field>
                            <button type="button" (click)="selectFile()" *ngIf="isFileSelected"
                                class="badge bg-light-blue image-button">
                                <img src="../../../../assets/Home-Connect/icons/upload-Icon.svg" style="width: 26px;" />
                            </button>
                            <button type="button" (click)="reset()" *ngIf="!isFileSelected"
                                class="badge bg-light-blue image-button">
                                <img style="filter: invert(1);width: 26px;"
                                    src="../../../../assets/Home-Connect/icons/delete.svg" />
                            </button>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-xl-12 text-center">
                            <button class="btn btn-secondary" (click)="closeUpload()" *ngIf="!isFileSelected">
                                View
                            </button>
                        </div>
                    </div>
                </div>
            </form>
            <div *ngIf="displayType === 'uploadExcelFileTable'">
                <div class="row">
                    <div class="col-md-4 mt-3" style="text-align: start;">
                        <img src="assets/images/svg/back-button.svg" class="pointer" width="30px" height="30px"
                            style="cursor:pointer;" mat-raised-button #tooltip="matTooltip" matTooltip="Back"
                            [matTooltipPosition]="position.value!" matTooltipHideDelay="100000"
                            aria-label="Button that displays a tooltip that hides when scrolled out of the container"
                            class="example-button" (click)="goBack()">
                    </div>
                    <div class="col-md-8 pl-4 mt-3" style="text-align: right;">
                        <!-- <input type="file" (change)="onFileSelected($event)" /> -->
                        <button class="btn btn-secondary" (click)="sendToPaySoft()">Submit To PaySoft</button>
                    </div>
                </div>
                <div class="table-responsive mt-3 scrollable-table-wrapper">
                    <mat-table #table [dataSource]="dataSource" matSort matSortDirection="asc">
                        <ng-container matColumnDef="CustomerCode">
                            <mat-header-cell *matHeaderCellDef
                                mat-sort-header="CustomerCode">CustomerCode</mat-header-cell>
                            <mat-cell *matCellDef="let dataField">
                                <p class="text-truncate txtalign">
                                    {{dataField.CustomerCode}}</p>
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="CustomerName">
                            <mat-header-cell *matHeaderCellDef
                                mat-sort-header="CustomerName">CustomerName</mat-header-cell>
                            <mat-cell *matCellDef="let dataField">
                                <p class="text-truncate txtalign">
                                    {{dataField.CustomerName}}</p>
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="Reference">
                            <mat-header-cell *matHeaderCellDef mat-sort-header="Reference">Reference</mat-header-cell>
                            <mat-cell *matCellDef="let dataField">
                                <p class="text-truncate txtalign">
                                    {{dataField.Reference}}</p>
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="Amount">
                            <mat-header-cell *matHeaderCellDef mat-sort-header="Amount">Amount</mat-header-cell>
                            <mat-cell *matCellDef="let dataField">
                                <p class="text-truncate txtalign">
                                    {{dataField.Amount}}</p>
                            </mat-cell>
                        </ng-container>

                        <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple>
                        </mat-row>
                    </mat-table>
                </div>
                <div class="table_pagenation">
                    <mat-paginator #paginator [length]="dataSource!==null && dataSource.filteredData.length"
                        [pageIndex]="0" [pageSize]="50" [pageSizeOptions]="[50, 100, 250, 500]">
                    </mat-paginator>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row" *ngIf="displayType === 'suspension' || displayType === 'uploadSuspensionExcelFile'">
    <div class="col-md-12">
        <div class="row modal_header">
            <div class="col-9">
                <span>Upload Suspension Data</span>
            </div>
            <div class="col-3 text-right">
                <a style="cursor:pointer">
                    <i class="fa-solid fa-xmark" (click)="Close()" style="font-size: x-large;"></i>
                </a>
            </div>
        </div>
        <div class="card card_content">
            <form [formGroup]="UploadExcelFileForm" *ngIf="displayType === 'suspension'">
                <div>
                    <div style="font-size: 15px;">
                        Click the upload button to attach the Pre‑Notification or Suspension Excel file.
                    </div>
                    <div class="row my-2 d-flex justify-content-center">
                        <div class="col-md-9 padd-right-file" style="display: flex;">
                            <mat-form-field appearance="fill" hideRequiredMarker (click)="selectFile()">
                                <mat-label>Pre-notification / Suspension File</mat-label>
                                <input matInput id="AttachmentFileName"
                                    [placeholder]="fileName ? '' : 'Select Attachment'" [value]="fileName"
                                    formControlName="AttachmentFileName" autocomplete="off" specialIsAlphaNumeric
                                    class="col-10" readonly>
                            </mat-form-field>
                            <button type="button" (click)="selectFile()" *ngIf="isFileSelected"
                                class="badge bg-light-blue image-button">
                                <img src="../../../../assets/Home-Connect/icons/upload-Icon.svg" style="width: 26px;" />
                            </button>
                            <button type="button" (click)="reset()" *ngIf="!isFileSelected"
                                class="badge bg-light-blue image-button">
                                <img style="filter: invert(1);width: 26px;"
                                    src="../../../../assets/Home-Connect/icons/delete.svg" />
                            </button>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-xl-12 text-center">
                            <button class="btn btn-secondary" (click)="closeUpload()" *ngIf="!isFileSelected">
                                View
                            </button>
                        </div>
                    </div>
                </div>
            </form>
            <div *ngIf="displayType === 'uploadSuspensionExcelFile'">
                <div class="row">
                    <div class="col-md-4 mt-3" style="text-align: start;">
                        <img src="assets/images/svg/back-button.svg" class="pointer" width="30px" height="30px"
                            style="cursor:pointer;" mat-raised-button #tooltip="matTooltip" matTooltip="Back"
                            [matTooltipPosition]="position.value!" matTooltipHideDelay="100000"
                            aria-label="Button that displays a tooltip that hides when scrolled out of the container"
                            class="example-button" (click)="goBack()">
                    </div>
                    <div class="col-md-8 pl-4 mt-3" style="text-align: right;">
                        <button class="btn btn-secondary" (click)="proceedForSuspensionProcess()">Submit</button>
                    </div>
                </div>
                <div class="table-responsive mt-3 scrollable-table-wrapper">
                    <mat-table #table [dataSource]="dataSource" matSort matSortDirection="asc">
                        <ng-container matColumnDef="CustomerNumber">
                            <mat-header-cell *matHeaderCellDef
                                mat-sort-header="CustomerNumber">CustomerNumber</mat-header-cell>
                            <mat-cell *matCellDef="let dataField">
                                <p class="text-truncate txtalign">
                                    {{dataField.CustomerNumber}}</p>
                            </mat-cell>
                        </ng-container>


                        <ng-container matColumnDef="Balance">
                            <mat-header-cell *matHeaderCellDef mat-sort-header="Balance">Balance</mat-header-cell>
                            <mat-cell *matCellDef="let dataField">
                                <p class="text-truncate txtalign">
                                    {{dataField.Balance}}</p>
                            </mat-cell>
                        </ng-container>

                        <mat-header-row *matHeaderRowDef="displayedColumnsSuspension; sticky:true"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: displayedColumnsSuspension;" matRipple>
                        </mat-row>
                    </mat-table>
                </div>
                <div class="table_pagenation">
                    <mat-paginator #paginator [length]="dataSource!==null && dataSource.filteredData.length"
                        [pageIndex]="0" [pageSize]="50" [pageSizeOptions]="[50, 100, 250, 500]">
                    </mat-paginator>
                </div>
            </div>
        </div>
    </div>
</div>